import { useEffect, useState } from 'react'

const SCROLL_THRESHOLD = 50

export const useScrolled = () => {
  const [isScrolled, setIsScrolled] = useState(() =>
    typeof window === 'undefined' ? false : window.scrollY > SCROLL_THRESHOLD
  )

  useEffect(() => {
    let frameId: number | null = null

    const updateScrolled = () => {
      const nextIsScrolled = window.scrollY > SCROLL_THRESHOLD
      setIsScrolled((current) => (current === nextIsScrolled ? current : nextIsScrolled))
      frameId = null
    }

    const handleScroll = () => {
      if (frameId === null) {
        frameId = window.requestAnimationFrame(updateScrolled)
      }
    }

    updateScrolled()
    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      if (frameId !== null) {
        window.cancelAnimationFrame(frameId)
      }
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return isScrolled
}
